<template>
  <div
    class="dashboard-page"
    :class="{ 'dashboard-page--no-header': hideHeader }"
  >
    <header v-if="!hideHeader && title" class="dashboard-page__header mt-0">
      <div class="dashboard-page__titles w-100">
        <h1 class="page-title">{{ title }}</h1>
        <p v-if="subtitle" class="dashboard-page__subtitle">{{ subtitle }}</p>
      </div>
      <div class="dashboard-page__actions">
        <slot name="actions"></slot>
      </div>
    </header>
    <div class="dashboard-page__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard-page',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.dashboard-page {
  padding-top: 1.25rem;
}

.dashboard-page--no-header {
  padding-top: 0;
}

.dashboard-page__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  min-height: 2.5rem;
  margin-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

@media (max-width: 1200px) {
  .dashboard-page__titles {
    margin-left: 40px;
    padding-left: 5px;
  }
}

@media (max-width: 767.98px) {
  .dashboard-page__titles {
    display: block;
    margin: 0;
    margin-left: 0px;
    line-height: 1.3;
    margin-left: 50px;
    padding-left: 5px;
  }
}

@media (min-width: 768px) {
  .dashboard-page__header {
    padding-left: 30px;
    padding-right: 30px;
  }
}

.dashboard-page__titles {
  min-width: 0;
  width: 100%;
}

.dashboard-page__header .page-title {
  display: block;
  margin: 0;
  font-size: 1.25rem;
  line-height: 1.3;
  text-transform: uppercase;
  color: #0a495ca8;
}

@media (max-width: 767.98px) {
  .dashboard-page__header .page-title {
    font-size: 1rem;
  }
}

.dashboard-page__subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.875rem;
  line-height: 1.3;
  color: #525f7f;
}

.dashboard-page__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.5rem;
}

.dashboard-page__actions:empty {
  display: none;
}
</style>
